import React from 'react';

const AppWideOrdersContext = React.createContext();

export default AppWideOrdersContext;
